<template>
    <form v-on:submit.prevent="register()" class="container-fluid">
        <div class="py-3">
            <h4 class="text-primary">Création d'un compte</h4>
            <div class="alert alert-danger" role="alert" v-if="message">{{ message }}</div>
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">@</span>
            </div>
            <input
                type="text"
                v-model="item.email"
                class="form-control"
                placeholder="identifiant"
                required
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">*</span>
            </div>
            <input
                type="password"
                v-model="item.password"
                class="form-control"
                placeholder="mot de passe"
                required
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">*</span>
            </div>
            <input
                type="password"
                v-model="item.password_confirmation"
                class="form-control"
                placeholder="Confirmation de mot de passe"
                required
            />
        </div>

        <div class="text-right mb-3">
            <button type="submit" class="btn btn-outline-primary">Créer mon compte</button>
        </div>

        <div class="text-right">
            <a class="text-primary" href="#">Consultez notre politique de confidentialité</a>
        </div>
    </form>
</template>

<script>
export default {
    name: "Register",
    data() {
        return {
            item: {},
            message: "",
            errors: {}
        };
    },
    created() {},
    methods: {
        register() {
            this.$store
                .dispatch("registerAction", {
                    email: this.item.email,
                    password: this.item.password
                })
                .then(() => {
                    this.$emit("close");
                })
                .catch(error => {
                    console.log(error);
                    this.message = error;
                });
        }
    }
};
</script>